import {useState} from "react";
import {Box, Modal} from "@mui/material";
import StreamsList from "../components/StreamsList";
import StreamForm from "../components/StreamForm";
import {useAlert} from "../context/AlertContext";
import {ApiError} from "../types/api-errors";

const AdminStreamsPage = () => {
    const {showAlert} = useAlert();

    const [open, setOpen] = useState(false);
    const [refresh, setRefresh] = useState(false);

    const refreshStreams = () => setRefresh(prev => !prev);

    const handleStreamAdded = () => {
        setOpen(false);
        refreshStreams();
        showAlert("Stream created successfully!", "success");
    };

    const handleError = (error: ApiError | any) => {
        const msg =
            typeof error === "string"
                ? error
                : error?.message ?? "Unexpected error";
        showAlert(msg, "error");
    };

    return (
        <Box sx={{px: {xs: 3, md: 3}}}>
            <StreamsList
                onAdd={() => setOpen(true)}
                refreshTrigger={refresh}
                refreshStreams={refreshStreams}
            />

            <Modal open={open} onClose={() => setOpen(false)}>
                <Box sx={{margin: "auto", width: 400}}>
                    <StreamForm
                        onClose={() => setOpen(false)}
                        onSuccess={handleStreamAdded}
                        onError={handleError}
                    />
                </Box>
            </Modal>
        </Box>
    );
};

export default AdminStreamsPage;
